export default __webpack_public_path__ + "static/media/Star.11eed46a.svg";